import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import moment from 'moment'

var fechaHoy = moment().format('YYYY-MM-DD');

//constantes
const dataInicial = {
    data: {},
    fc_05: {
        nombrerazonsocial: '',
        numerocliente: '',
        correoelectronico: '',
        telefono: '',
        fechasolicitud: fechaHoy,
        embalaje: false,
        facturas: false,
        folletostripticos: false,
        paginaweb: false,
        espectaculares: false,
        rotuladoparedes: false,
        otrosdocumentos: false,
        especificacionesotrosdocumentos: ''
    },
    loading: false,
    modoEdicionBorrador: false,
    fc_05Map: {},
    modoCorreccion: false,
    cliente: [],
    dataLogin: [],
    paginaActiva: 1,
    files: [],
    dataDocumentacion: {},
    filesMap: [],
}

//types
const AGREGAR_FC_05_EXITO = 'AGREGAR_FC_05_EXITO'
const OBTENER_FC_05_CONTADOR_FECHA_FOLIO_EXITO = 'OBTENER_FC_05_CONTADOR_FECHA_FOLIO_EXITO'
const OBTENER_CLIENTE_POR_LOGIN_EXITO_05 = 'OBTENER_CLIENTE_POR_LOGIN_EXITO_05'
const OBTENER_FC_05_DETALLE_PARA_DOCUMENTACION_EXITO = 'OBTENER_FC_05_DETALLE_PARA_DOCUMENTACION_EXITO'
const AGREGAR_FC_05_FECHA_EXITO = 'AGREGAR_FC_05_FECHA_EXITO'
const AGREGAR_ARCHIVO_FC_05_EXITO = 'AGREGAR_ARCHIVO_FC_05_EXITO'
const ACTUALIZAR_ARCHIVO_FC_05_EXITO = 'ACTUALIZAR_ARCHIVO_FC_05_EXITO'

const AGREGAR_FC_05_BORRADOR_EXITO = 'AGREGAR_FC_05_BORRADOR_EXITO'
const OBTENER_FC_05_DETALLE_EXITO = 'OBTENER_FC_05_DETALLE_EXITO'
const ACTUALIZAR_FC_05_ESTATUS_EXITO = 'ACTUALIZAR_FC_05_ESTATUS_EXITO'
const ELIMINAR_FC_05_SOLICITUD_EXITO_BD = 'ELIMINAR_FC_05_SOLICITUD_EXITO_BD'
const OBTENER_FC_05_MAP_EXITO = 'OBTENER_FC_05_MAP_EXITO'

export const agregarFC_05Accion = createAsyncThunk(
    AGREGAR_FC_05_EXITO,
    async (data) => {
        try {
            const fullUrl = host + `FC_05/agregarNuevoFC_05UsoDeMarca`
            const res = await axios.post(fullUrl, { data: data })
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerContadorDeFechaFolio = createAsyncThunk(
    OBTENER_FC_05_CONTADOR_FECHA_FOLIO_EXITO,
    async (year) => {
        try {
            const fullUrl = host + `Estatus/ContadorGeneralDeFechasFolio/year=${year}`
            const res = await axios.get(fullUrl)
            const contador =
                res.data.data.resultfc_01[0].count + res.data.data.resultfc_05[0].count + res.data.data.resultfc_06[0].count +
                res.data.data.resultfc_08[0].count + res.data.data.resultfc_09[0].count + res.data.data.resultfc_30[0].count +
                res.data.data.resultfc_31[0].count + res.data.data.resultfc_33[0].count + res.data.data.resultfc_34[0].count +
                res.data.data.resultfc_35[0].count + res.data.data.resultfc_36[0].count + res.data.data.resultfc_40[0].count +
                res.data.data.resultfc_41[0].count
            return contador
        } catch (error) {
            console.log(error)
        }
    }
)
export const ObtenerClientePorLogin05 = createAsyncThunk(
    OBTENER_CLIENTE_POR_LOGIN_EXITO_05,
    async (params) => {
        try {
            const fullUrl = host + `InformacionValida/obtenerClientePorLogin/${params.idlogin}`
            const res = await axios.get(fullUrl)
            let idcartera = res.data.data.idcartera
            const fullUrlDatosLogin = host + `AnexoUsuario/obtenerDatosLoginPorCartera/${idcartera}`
            const resdatoslogin = await axios.get(fullUrlDatosLogin)
            let datos = []
            datos.push(res.data.data, resdatoslogin.data.data)
            return datos
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerFC_05SolicitudDetalleParaDocumentacion = createAsyncThunk(
    OBTENER_FC_05_DETALLE_PARA_DOCUMENTACION_EXITO,
    async (idSolicitud) => {
        try {
            const fullUrl = host + `FC_05/obtenerFormatoFC05_ConDetalle/${idSolicitud}`
            const res = await axios.get(fullUrl)

            const documentosFC_05 = []
            //FILES
            for (const i in res.data.data.fc_05archivos) {
                const { ...anexo } = res.data.data.fc_05archivos[i]
                const data = {
                    id: anexo.nameid,
                    file: { name: await getNameFile(anexo.ruta) },
                    idAnexo: anexo.idfc_05archivos,
                    idAnexoFK: res.data.data.idfc05_solicitudusomarcaeimagen,
                    estatus: true,
                }

                documentosFC_05.push(data)
            }

            return { data: res.data.data, documentosFC_05 }
        } catch (error) {
            console.log(error);
        }
    }
)
const getNameFile = async (ruta) => {
    let nameFile = null
    const array = ruta.split("/")
    // const array = ruta.split("\\")//local
    nameFile = array[array.length - 1]
    return nameFile
}
export const actualizarFC_05Fecha = createAsyncThunk(
    AGREGAR_FC_05_FECHA_EXITO,
    async (data) => {
        try {
            const actualizarFC_05 = host + `FC_05/actualizarFC_05UsoDeMarca`
            const res = await axios.put(actualizarFC_05, { data: data })
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const agregarFileFC_05 = createAsyncThunk(
    AGREGAR_ARCHIVO_FC_05_EXITO,
    async (data) => {
        try {
            const { archivo, ruta } = data
            const result = await agregarFile(archivo, ruta)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)
const agregarFile = async (data, url) => {
    let formData = new FormData();
    formData.append(1, data.file)
    formData.append('nameId', data.id)
    formData.append('idSolicitud', data.idAnexoFK)
    const resFile = await axios.post(host + url, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
    return resFile
}
export const actualizarFileFC_05 = createAsyncThunk(
    ACTUALIZAR_ARCHIVO_FC_05_EXITO,
    async (data) => {
        try {
            const { archivo, ruta } = data
            const result = await actualizarFile(archivo, ruta)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)
const actualizarFile = async (data, url) => {
    let formData = new FormData();
    formData.append(1, data.file)
    formData.append('nameId', data.id)
    formData.append('idSolicitud', data.idAnexo)
    formData.append('idSolicitudFK', data.idAnexoFK)
    const resFile = await axios.put(host + url, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
    return resFile
}
export const eliminarFC_05SolicitudBD = createAsyncThunk(
    ELIMINAR_FC_05_SOLICITUD_EXITO_BD,
    async (id) => {
        try {
            const fullUrlSolicitud = host + `FC_05/eliminarFC_05UsoDeMarca/${id}`
            const resultDelete = await axios.delete(fullUrlSolicitud)
            return { id }
        } catch (error) {
            console.log(error);
        }
    }
)
export const actualizarFC_05SolicitudBorrador = createAsyncThunk(
    AGREGAR_FC_05_BORRADOR_EXITO,
    async (data) => {
        try {
            const solicitud = { data: data }

            const agregarFC_05 = host + `FC_05/actualizarFC_05UsoDeMarca`
            const res = await axios.put(agregarFC_05, solicitud)
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
const obtenerAchivosMap = async (idSolicitud) => {
    try {
        const fullUrl = host + `FC_05/obtenerFormatoFC05_ConDetalle/${idSolicitud}`
        const obtenerArchivosGeneralMap = host + `MapSolicitud/obtenerMapFC_05_ArchivosGenerales/`
        const res = await axios.get(fullUrl)
        const filesGeneral = res.data.data.fc_05archivos
        const filesGeneralMap = []

        for (const i in filesGeneral) {
            const resfiles = await axios.get(obtenerArchivosGeneralMap + filesGeneral[i].idfc_05archivos)
            if (resfiles.data.data) {
                resfiles.data.data.idAnexoBD = resfiles.data.data.idfc_05archivos
                resfiles.data.data.nameid = ""
                filesGeneralMap.push(resfiles.data.data)
            }
        }
        let Map = { filesGeneralMap: filesGeneralMap }
        return Map
    } catch (error) {
        console.log(error);
    }
}











export const obtenerFC_05Map = createAsyncThunk(
    OBTENER_FC_05_MAP_EXITO,
    async (solicitudId) => {
        try {
            const fullUrl = host + `MapSolicitud/obtenerMapFC_05_SolicitudParaAutorizacionUsoMarcaEImagenMap/${solicitudId}`
            const res = await axios.get(fullUrl)
            const Map = await obtenerAchivosMap(solicitudId)
            return { data: res.data.data, filesMap: Map.filesGeneralMap }
        } catch (error) {
            console.log(error)
        }
    }
)
export const actualizarFC_05Estatus = createAsyncThunk(
    ACTUALIZAR_FC_05_ESTATUS_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'Estatus/actualizarEstatusTablas'
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const agregarFC_05SolicitudBorrador = createAsyncThunk(
    AGREGAR_FC_05_BORRADOR_EXITO,
    async (data) => {
        try {
            const fullUrl = host + `FC_05/agregarFormatoFC05`
            const res = await axios.post(fullUrl, { data })
            return data
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerFC_05SolicitudDetalle = createAsyncThunk(
    OBTENER_FC_05_DETALLE_EXITO,
    async (idSolicitud) => {
        try {
            const fullUrl = host + `FC_05/obtenerFormatoFC05_ConDetalle/${idSolicitud}`
            const res = await axios.get(fullUrl)
            const documentosFC_05 = []
            //FILES
            for (const i in res.data.data.fc_05archivos) {
                const { ...anexo } = res.data.data.fc_05archivos[i]
                const data = {
                    id: anexo.nameid,
                    file: { name: await getNameFile(anexo.ruta) },
                    idAnexo: anexo.idfc_05archivos,
                    idAnexoFK: res.data.data.idfc05_solicitudusomarcaeimagen,
                    estatus: true,
                }
                documentosFC_05.push(data)
            }
            return { data: res.data.data, documentosFC_05 }
        } catch (error) {
            console.log(error);
        }
    }
)

export const fc05Slice = createSlice({
    name: 'fc05Slice',
    initialState: dataInicial,
    reducers: {
        actualizarFC_05PaginaActiva(state, { payload }) {
            state.paginaActiva = payload
        },

        guardarCambiosFC_05SolicitudBorrador(state, { payload }) {
            state.data = payload
        },
        guardarCambiosFC_05SolicitudNueva(state, { payload }) {
            state.fc_05 = payload
        },
        actualizarModoBorradorFC_05(state, { payload }) {
            state.modoEdicionBorrador = payload
        },
        setModoCorrecionFC_05(state, { payload }) {
            state.modoCorreccion = payload
        },
        resetDataFC_05(state, { payload }) {
            return dataInicial
        },
    },
    extraReducers: {
        [ObtenerClientePorLogin05.fulfilled]: (state, { payload }) => {
            state.cliente = payload[0]
            state.dataLogin = payload[1][0]
        },
        [agregarFC_05Accion.fulfilled]: (state, { payload }) => {
        },
        [obtenerFC_05SolicitudDetalleParaDocumentacion.fulfilled]: (state, { payload }) => {
            state.dataDocumentacion = payload.data
            state.files = { data: payload.documentosFC_05 }
        },




        [agregarFC_05SolicitudBorrador.fulfilled]: (state, { payload }) => {
        },
        [actualizarFC_05Estatus.fulfilled]: (state, { payload }) => {
        },
        [actualizarFC_05SolicitudBorrador.fulfilled]: (state, { payload }) => {
        },
        [obtenerFC_05SolicitudDetalle.fulfilled]: (state, { payload }) => {
            state.data = payload?.data
            state.fc_05 = payload?.data
            state.dataDocumentacion = payload?.data
            state.files = payload?.documentosFC_05
        },
        [eliminarFC_05SolicitudBD.fulfilled]: (state, { payload }) => {
        },
        [obtenerFC_05Map.fulfilled]: (state, { payload }) => {
            state.fc_05Map = payload.data
            state.filesMap = payload.filesMap
        }
    },
})

//actions
export const {
    actualizarFC_05PaginaActiva,
    guardarCambiosFC_05SolicitudBorrador, guardarCambiosFC_05SolicitudNueva,
    actualizarModoBorradorFC_05, resetDataFC_05, setModoCorrecionFC_05
} = fc05Slice.actions

export const FC05ReducerBeneficiario = fc05Slice.reducer